// extracted by mini-css-extract-plugin
export default {"root":"UserHeader_root__1w0tf","organizationSelect":"UserHeader_organizationSelect__I2tsY"};